export default "/static/webpack/media/grey-clock.d27f1d6a.svg";